export default __webpack_public_path__ + "static/081-f9d591d15b163f2d4cee16146d0650c5.jpg";